import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb } from 'vhautowebdb'; 

@Component({
  selector: 'atw-menu-product-config',
  templateUrl: './menu-product-config.component.html',
  styleUrls: ['./menu-product-config.component.scss'],
})
export class AtwMenuProductConfig   {
   
}
